<template>
  <div class="commonBottom ">
    <div class="section">
      <div class="bottom" v-if="this.language == 'cn'">
        <div class="bottom_left">
          <div class="bottom_left_path">
            <div @click="handleChange(1)">
              <router-link class="bottomText" to="index">
                <div>首页</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(2)">
              <router-link class="bottomText" to="exhibition">
                <div>作品展</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(4)">
              <router-link class="bottomText" to="exhibitionSale">
                <div>作品展销</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(5)">
              <router-link class="bottomText" to="culture">
                <div>设计与展销</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(3)">
              <router-link class="bottomText" to="database">
                <div>数据库</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(9)">
              <router-link class="bottomText" to="news">
                <div>新闻动态</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(10)">
              <router-link class="bottomText" to="about">
                <div>关于我们</div>
              </router-link>
            </div>
          </div>
          <div class="bottom_left_school">
            <div class="school_left">
              <span>负责单位：</span>
              <a href="https://www.qhnu.edu.cn/" target="_blank">青海师范大学</a>
            </div>
            <div class="school_right">
               <span>合作单位：</span>
               <a href="http://www.hfut.edu.cn/" target="_blank">合肥工业大学</a>
               <span>、</span>
               <a href="http://www.yarlung.cn/" target="_blank">青海珠穆雅鲁</a>
               <span>、</span>
               <span>青海省非物质文化遗产研究基地</span>
            </div>
          </div>
          <div class="bottom_left_email">
            <div>联系邮箱：regong_art_db@163.com</div>
          </div>
          <div class="bottom_left_ICP">
            <div class="bottom_left_ICP_left">Copyright©青海师范大学</div>
            <div class="bottom_left_ICP_right" style="cursor: pointer;" @click="handleICP()">All Rights Reserved 京ICP备07504941号-3 京公安网备 11010502042400</div>
          </div>
          <div class="bottom_left_web">
            <div class="bottom_left_web_left">
              <div class="bottom_left_web_left_left">
                <span>网站建设：</span>
                <a href="http://www.hfut.edu.cn/" target="_blank">合肥工业大学</a>
                <span>、</span>
                <a href="https://www.qhnu.edu.cn/" target="_blank">青海师范大学</a>
              </div>
              <div class="bottom_left_web_left_right">访客统计：{{statistics}}</div>
            </div>
            <div class="bottom_left_web_right">技术支持：安徽常道信息技术有限公司</div>
          </div>
        </div>
        <div class="bottom_right">
          <div class="imgItem" v-for="(item,index) in bottom" :key="index">
            <img :src="item.imgSrc" alt="">
          </div>
        </div>
      </div>
      <div class="bottom engListBottom" v-if="this.language == 'eng'">
        <div class="bottom_left">
          <div class="bottom_left_path">
            <div @click="handleChange(1)">
              <router-link class="bottomText" to="index">
                <div>Home</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(2)">
              <router-link class="bottomText" to="exhibition">
                <div>Exhibition</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(4)">
              <router-link class="bottomText" to="exhibitionSale">
                <div>Sales</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(5)">
              <router-link class="bottomText" to="culture">
                <div>Design</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(3)">
              <router-link class="bottomText" to="database">
                <div>Database</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(9)">
              <router-link class="bottomText" to="news">
                <div>News</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(10)">
              <router-link class="bottomText" to="about">
                <div>About</div>
              </router-link>
            </div>
          </div>
          <div class="bottom_left_school">
            <div class="school_left">
               <span>Responsible Units：</span>
               <a href=" https://www.qhnu.edu.cn/" target="_blank">QHNU</a>
            </div>
            <div class="school_right">
               <span>Cooperation Units：</span>
               <a href="http://www.hfut.edu.cn/" target="_blank">HFUT</a>
               <span>、</span>
               <a href="http://www.yarlung.cn/" target="_blank">YARLUNG</a>
               <span>、</span>
               <span>Qinghai ICH Research Base</span>
            </div>
          </div>
          <div class="bottom_left_email">
            <div>Email：regong_art_db@163.com</div>
          </div>
          <div class="bottom_left_ICP">
            <div class="bottom_left_ICP_left">Copyright©Qinghai Normal University</div>
            <div class="bottom_left_ICP_right" style="cursor: pointer;" @click="handleICP()">All Rights Reserved 京ICP备07504941号-3 京公安网备 11010502042400</div>
          </div>
          <div class="bottom_left_web">
            <div class="bottom_left_web_left">
              <div class="bottom_left_web_left_left">
                <span>Website Construction：</span>
                <!-- QHUT HFUT -->
                <a href="http://www.hfut.edu.cn/" target="_blank">HFUT</a>
                <span>、</span>
                <a href=" https://www.qhnu.edu.cn/" target="_blank">QHNU</a>
              </div>
              <div class="bottom_left_web_left_right">Visitor Statistics：{{statistics}}</div>
            </div>
            <div class="bottom_left_web_right">Technical Support：AnHui Tao Info Tech Co., Ltd.</div>
          </div>
        </div>
        <div class="bottom_right">
          <div class="imgItem" v-for="(item,index) in bottom" :key="index">
            <img :src="item.imgSrc" alt="">
          </div>
        </div>
      </div>
      <div class="bottom zangBottom" v-if="this.language == 'en'">
        <div class="bottom_left">
          <div class="bottom_left_path">
            <div @click="handleChange(1)">
              <router-link class="bottomText" to="index">
                <div>ངོ་བྱང་།</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(2)">
              <router-link class="bottomText" to="exhibition">
                <div>བརྩམས་ཆོས་འགྲེམ་སྟོན།</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(4)">
              <router-link class="bottomText" to="exhibitionSale">
                <div>བྲིན་ཚོང་</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(5)">
              <router-link class="bottomText" to="culture">
                <div>ཇུས་འགོད་</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(3)">
              <router-link class="bottomText" to="database">
                <div>གྲངས་མཛོད།</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(9)">
              <router-link class="bottomText" to="news">
                <div>གསར་འགྱུར།</div>
              </router-link>
            </div>
            <div class="line">|</div>
            <div @click="handleChange(10)">
              <router-link class="bottomText" to="about">
                <div>ང་ཚོའི་སྐོར།</div>
              </router-link>
            </div>
          </div>
          <div class="bottom_left_school">
            <div class="school_left">
               <span>འགན་འཁུར་སྡེ་ཚན་：</span>
               <a href=" https://www.qhnu.edu.cn/" target="_blank">མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན།</a>
            </div>
            <div class="school_right hidden-xs-only">
               <span>མཉམ་འབྲེལ་ལས་ཁུངས།：</span>
               <a href="http://www.hfut.edu.cn/" target="_blank">ཧུ་ཧྥེ་བཟོ་ལས་སློབ་གྲྭ་ཆེན་མོ།</a>
               <span>、</span>
               <a href="http://www.yarlung.cn/" target="_blank">YARLUNG</a>
               <span>、</span>
               <span>མཚོ་སྔོན་ཞིང་ཆེན་དངོས་མིན་རིག་གནས་ཤུལ་བཞག་ཞིབ་འཇུག་ལྟེ་གནས།</span>
            </div>
            <div class="school_right hidden-sm-and-up">
               <div class="school_right_left">མཉམ་འབྲེལ་ལས་ཁུངས།：</div>
               <div class="school_right_right">
                <a href="http://www.hfut.edu.cn/" target="_blank">ཧུ་ཧྥེ་བཟོ་ལས་སློབ་གྲྭ་ཆེན་མོ།</a>
                <span>、</span>
                <a href="http://www.yarlung.cn/" target="_blank">YARLUNG</a>
                <span>、</span>
                <span>མཚོ་སྔོན་ཞིང་ཆེན་དངོས་མིན་རིག་གནས་ཤུལ་བཞག་ཞིབ་འཇུག་ལྟེ་གནས།</span>
               </div>
            </div>
          </div>
          <div class="bottom_left_email">
            <div>འབྲེལ་གཏུག་ཡིག་སྒམ་།：regong_art_db@163.com</div>
          </div>
          <div class="bottom_left_ICP">
            <div class="bottom_left_ICP_left">Copyright©མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན</div>
            <div class="bottom_left_ICP_right hidden-xs-only" style="cursor: pointer;" @click="handleICP()">All Rights Reserved པེ་ཅིངICPཐོ་འགོད་སྙན་སེང07504941-3 པེ་ཅིང་སྤྱི་བདེའི་དྲ་ཚིགས་ཐོ་འགོད་སྙན་སེང 11010502042400</div>
            <div class="bottom_left_ICP_right hidden-sm-and-up" style="cursor: pointer;" @click="handleICP()">
              <div>All Rights Reserved པེ་ཅིངICPཐོ་འགོད་སྙན་སེང07504941-3 པེ་ཅིང་སྤྱི་བདེའི་དྲ་ཚིགས་ཐོ་འགོད་སྙན་སེང</div>
              <div>11010502042400</div>
            </div>
          </div>
          <div class="bottom_left_web">
            <div class="bottom_left_web_left">
              <div class="bottom_left_web_left_left">
                <span>དྲ་ངོས་བཟོ་སྐྲུན།：</span>
                <a href="http://www.hfut.edu.cn/" target="_blank">མཚོ་སྔོན་དགེ་འོས་སློབ་ཆེན</a>
                <span>、</span>
                <a href="https://www.qhnu.edu.cn/" target="_blank">ཧུ་ཧྥེ་བཟོ་ལས་སློབ་གྲྭ་ཆེན་མོ།</a>
              </div>
              <div class="bottom_left_web_left_right">མགྲོན་པོའི་སྡོམ་རྩིས།：{{statistics}}</div>
            </div>
            <div class="bottom_left_web_right">ལག་རྩལ་རོགས་འདེགས། ：ཨན་ཧེ་ཁྲང་ཏོ་བརྡ་འཕྲིན་ལག་རྩལ་ཚད་ཡོད་ཀུང་ཟི།</div>
          </div>
        </div>
        <div class="bottom_right">
          <div class="imgItem" v-for="(item,index) in bottom" :key="index">
            <img :src="item.imgSrc" alt="">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
    changeStatistics() {
      return this.$store.state.statistics;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
    changeStatistics: function (val) {
      this.statistics = val;
    },
  },
  data() {
    return {
      language: this.$store.state.language,
      statistics: this.$store.state.statistics,
      bottom:[
        {
          id:1,
          imgSrc:require("../assets/qrCode/01_小红书热贡艺术.png")
        },
        {
          id:2,
          imgSrc:require("../assets/qrCode/YARLUNG新观察.png")
        },
        {
          id:3,
          imgSrc:require("../assets/qrCode/视频号：正好是个设计鬼才.png")
        },
        {
          id:4,
          imgSrc:require("../assets/qrCode/设计号：正好是个设计鬼才.png")
        },
      ]
    }
  },
  methods: {
    handleChange(num) {
      this.$store.commit("changeNum", num);
    },
    handleICP() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index")
    }
  },
}
</script>
<style lang="scss">
.commonBottom {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 40px 0;
  background-size: contain;
  background: url("../assets/indexImage/bottomNew.jpg");
  color: #fff;
  .section {
    .bottom {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .bottom_left{
        width: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 18px;
        .bottom_left_path {
          display: flex;
          margin-bottom: 25px;
          div {
            a {
              div {
                 color: #fff;
              }
            }
          }
          .line {
            font-size: 20px;
            color: #fff;
            padding: 0 10px;
            display: flex;
            align-items: center;
            height: 22px;
          }
        }
        .bottom_left_school {
          display: flex;
          margin-bottom: 25px;
          .school_left {
            margin-right: 30px;
          }
          div {
            a {
              color: #fff;
              text-decoration: underline;
            }
          }
        }
        .bottom_left_email {
          margin-bottom: 25px;
        }
        .bottom_left_ICP{
          margin-bottom: 25px;
          display: flex;
        }
        .bottom_left_web {
          display: flex;
          justify-content: space-evenly;
          .bottom_left_web_left {
            display: flex;
            margin-right: 10px;
            .bottom_left_web_left_left {
              display: flex;
              justify-content: space-between;
              margin-right: 10px;
              a {
                color: #fff;
                text-decoration: underline;
              }
            }
          }
        }
      }
      .bottom_right{
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .imgItem {
          width: 113px;
          height: 113px;
          margin-bottom: 20px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .imgItem:nth-child(2) {
          margin-right: 0;
        }
        .imgItem:nth-child(3) {
          margin-bottom: 0;
        }
        .imgItem:nth-child(4) {
          margin-bottom: 0;
          margin-right: 0;
        }
      }
    }
    .engListBottom {
      font-family: 'Times New Roman', Times, serif;
    }
    .zangBottom, .engListBottom {
      .bottom_left {
        width: 78%;
      }
      .bottom_right {
        width: 22%;
      }
    }
  }
}
@media (max-width: 768px) {
  .commonBottom {
    padding: .5rem 0;
    .section {
      .bottom {
        flex-direction: column;
        .bottom_left {
          width: 100%;
          .bottom_left_path {
            margin-bottom: .2rem;
            align-items: center;
            div {
              a {
                div {
                  color: #fff;
                  font-size: .22rem;
                }
              }
            }
            .line {
              font-size: .22rem;
              padding: 0 .08rem;
              height: .22rem;
            }
          }
          .bottom_left_school {
            flex-direction: column;
            margin-bottom: .2rem;
            .school_left {
              width: 100%;
              text-align: center;
              margin-bottom: .1rem;
              span, a {
                font-size: .21rem;
              }
            }
            .school_right {
              width: 100%;
              display: flex;
              justify-content: center;
              font-size: .21rem;
            }
          }
          .bottom_left_email {
            margin-bottom: .2rem;
            font-size: .25rem;
          }
          .bottom_left_ICP {
            margin-bottom: .2rem;
            flex-direction: column;
            font-size: .218rem;
            .bottom_left_ICP_left {
              width: 100%;
              text-align: center;
              margin-bottom: .1rem;
            }
            .bottom_left_ICP_right {
              width: 100%;
              display: flex;
              justify-content: center;
              cursor: pointer;
            }
          }
          .bottom_left_web {
            font-size: .25rem;
            flex-direction: column;
            .bottom_left_web_left {
              width: 100%;
              display: flex;
              justify-content: space-evenly;
              margin-bottom: .1rem;
              a {
                color: #fff;
                text-decoration: underline;
              }
            }
            .bottom_left_web_right{
              width: 100%;
              text-align: center;
            }
          }
        }
        .bottom_right{
          margin-top: .2rem;
          width: 100%;
          .imgItem {
            width: 1.2rem;
            height: 1.2rem;
            margin-right: .2rem;
          }
          .imgItem:nth-child(1) {
            margin-right: .2rem;
            margin-bottom: 0;
          }
          .imgItem:nth-child(2) {
            margin-right: .2rem;
            margin-bottom: 0;
          }
          .imgItem:nth-child(4) {
            margin-right: 0;
          }
        }
      }
      .zangBottom {
        .bottom_left {
          .bottom_left_school {
            .school_right {
              display: flex;
              flex-direction: column;
              .school_right_left {
                width: 100%;
                text-align: center;
                margin-bottom: .1rem;
              }
              .school_right_right{
                width: 100%;
                display: flex;
                justify-content: center;
              }
            }
          }
          .bottom_left_ICP{
            .bottom_left_ICP_right {
              display: flex;
              flex-direction: column;
              >div {
                display: flex;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>